export default __webpack_public_path__ + "static/media/taxefy_icon.d95c04e7.png";